import { render, staticRenderFns } from "./AttributeList.vue?vue&type=template&id=51cbbf24&scoped=true&"
import script from "./AttributeList.vue?vue&type=script&lang=js&"
export * from "./AttributeList.vue?vue&type=script&lang=js&"
import style0 from "./AttributeList.vue?vue&type=style&index=0&id=51cbbf24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cbbf24",
  null
  
)

export default component.exports